import { FC, ReactNode, memo } from "react";
import { useSelector } from "react-redux";
import { RootState } from "@/store/Store";
import { Skeleton } from "../Skeleton";

export interface SectionTitleProps {
    title?: string;
    subTitle?: string | ReactNode;
    lotNumber?: string;
    showLoading?: boolean;
}

const SectionTitle: FC<SectionTitleProps> = ({
    title,
    subTitle,
    lotNumber,
    showLoading = false
}) => {

    const { settings } = useSelector((state: RootState) => state.settings);

    return <>
        {
            showLoading ? (
                <Skeleton animation="wave" variant="text" component="h3" width="100%" />
            ): (
                    <>
                        {
                            title && lotNumber !== undefined && lotNumber !== null && (
                                <div className="pb-lot-title">
                                    <div className="pb-lot-title-number" style={settings?.Styles?.OverridePageTextColor ? { color: settings.Styles.OverridePageTextColor } : undefined}>
                                        {settings?.LotName} {lotNumber}
                                    </div>
                                    <h1 style={settings?.Styles?.OverridePageTextColor ? { color: settings.Styles.OverridePageTextColor } : undefined}>{title}</h1>
                                </div>
                            )
                        }

                        {
                            title && (lotNumber === undefined || lotNumber === null) &&
                            <h3 style={{
                                color: settings?.Styles?.OverridePageTextColor
                                    ? settings?.Styles?.OverridePageTextColor
                                    : "#000000",
                            }}>
                                <span
                                    className="text-black font-weight-bold"
                                    style={{
                                        whiteSpace: "pre-wrap",
                                        wordWrap: "break-word",
                                        color: settings?.Styles?.OverridePageTextColor
                                            ? settings?.Styles?.OverridePageTextColor
                                            : "#000000",
                                    }}
                                >
                                    {title}
                                </span>
                            </h3>
                        }

                        {
                            subTitle &&
                            <h4 style={{ color: settings?.Styles?.OverridePageSubTextColor ? settings?.Styles?.OverridePageSubTextColor : "#000000" }}>{subTitle}</h4>
                        }
                    </>
            )
        }
    </>
};

export default memo(SectionTitle);
